export const CausalRetiro = [
    {
        codigoCausal: 1,
        nombreCausal: "CANCELACIÓN POR LIQUIDACIÓN DE EMPRESA"
    }, {
        codigoCausal: 2,
        nombreCausal: "CANCELACIÓN POR SUSTITUCIÓN PATRONAL"
    },    {
        codigoCausal: 3,
        nombreCausal: "CANCELACIÓN POR FUSIÓN"
    }, {
        codigoCausal: 4,
        nombreCausal: "CANCELACIÓN POR ABSORCIÓN"
    },    {
        codigoCausal: 5,
        nombreCausal: "CANCELACIÓN POR CAMBIO DE NIT"
    }, {
        codigoCausal: 6,
        nombreCausal: "CANCELACIÓN POR RETIRO MASIVO DE TRABAJADORES"
    },    {
        codigoCausal: 7,
        nombreCausal: "CANCELACIÓN POR CESE DE ACTIVIDADES DEFINITIVAS"
    }, {
        codigoCausal: 8,
        nombreCausal: "DECISIÓN UNILATERAL DE TERMINAR EL CONTRATO"
    }];

export const obtenerCodigoEnvio = (codigoCausal: number) => {
    return CausalRetiro.find(causalRetiro => causalRetiro.codigoCausal === codigoCausal);
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/procesar_retiro/modelo/CausalRetiro.ts